import React from 'react';
import { MemoriaBlindada } from './pages/MemoriaBlindada';
export function App() {
  return <MemoriaBlindada data-id="element-0" />;
}